import { CheckboxField, DropdownField } from '@cian/components';
import * as React from 'react';
import { connect } from 'react-redux';
import { IAppState, Dispatch } from '../../../../common/state';
import { EMaxPrepay } from '../../../../json_query';
import { changeMaxPrepay, changeWithoutDeposit } from '../../../state/advanced/rent_terms';
import { InlineBlock, InlineLabel, Row } from '../markup';

export interface IRentTermsProps {
  maxPrepay: EMaxPrepay;
  onMaxPrepayChanged(value: EMaxPrepay): void;

  withoutDeposit: boolean;
  onWithoutDepositChanged(value: boolean): void;
}

export const rentTerms: React.StatelessComponent<IRentTermsProps> = props => (
  <Row title="Условия сделки">
    <InlineLabel>предоплата</InlineLabel>
    <InlineBlock>
      <DropdownField
        value={props.maxPrepay}
        onValueChange={(value: EMaxPrepay) => props.onMaxPrepayChanged(value)}
        values={[
          { value: EMaxPrepay.Any, label: 'любая' },
          { value: EMaxPrepay.Month, label: 'не более 1 месяца' },
          { value: EMaxPrepay.TwoMonths, label: 'не более 2 месяцев' },
          { value: EMaxPrepay.ThreeMonths, label: 'не более 3 месяцев' },
        ]}
      />
    </InlineBlock>
    <InlineBlock>
      <CheckboxField
        label="Без залога"
        value={props.withoutDeposit}
        onValueChange={value => props.onWithoutDepositChanged(value)}
      />
    </InlineBlock>
  </Row>
);

// tslint:disable-next-line:no-default-export
export default connect(
  (state: IAppState) => ({
    maxPrepay: (state.filters.jsonQuery.prepay && state.filters.jsonQuery.prepay.value) || EMaxPrepay.Any,
    withoutDeposit: state.filters.jsonQuery.zalog !== undefined ? !state.filters.jsonQuery.zalog.value : false,
  }),
  (dispatch: Dispatch) => ({
    onMaxPrepayChanged: (value: EMaxPrepay) => {
      dispatch(changeMaxPrepay(value));
    },
    onWithoutDepositChanged: (value: boolean) => {
      dispatch(changeWithoutDeposit(value));
    },
  }),
)(rentTerms);
